/**
 * Libertify Design System - Typography
 * Extracted from Figma Design System
 */

export const typography = {
  fontFamily: {
    primary: "'Poppins', sans-serif",
    secondary: "'Inter Variable', sans-serif",
  },

  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  // Display styles - for hero sections and large headings
  display: {
    large: {
      fontSize: 52,
      lineHeight: '56px',
      letterSpacing: '-1.04px',
      fontWeight: 600,
    },
    small: {
      fontSize: 44,
      lineHeight: '48px',
      letterSpacing: '-0.88px',
      fontWeight: 600,
    },
  },

  // Heading styles
  heading: {
    h1: {
      fontSize: 40,
      lineHeight: '48px',
      letterSpacing: '-0.8px',
      fontWeight: 600,
    },
    h2: {
      fontSize: 36,
      lineHeight: '44px',
      letterSpacing: '-0.72px',
      fontWeight: 600,
    },
    h3: {
      fontSize: 32,
      lineHeight: '40px',
      letterSpacing: '-0.64px',
      fontWeight: 600,
    },
    h4: {
      fontSize: 28,
      lineHeight: '36px',
      letterSpacing: '-0.56px',
      fontWeight: 600,
    },
    h5: {
      fontSize: 24,
      lineHeight: '32px',
      letterSpacing: '-0.48px',
      fontWeight: 600,
    },
  },

  // Body text styles
  body: {
    large: {
      fontSize: 18,
      lineHeight: '28px',
      letterSpacing: '0px',
      fontWeight: 400,
    },
    medium: {
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: '0px',
      fontWeight: 400,
    },
    small: {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0px',
      fontWeight: 400,
    },
    xsmall: {
      fontSize: 12,
      lineHeight: '16px',
      letterSpacing: '0px',
      fontWeight: 400,
    },
    xxsmall: {
      fontSize: 10,
      lineHeight: '20px',
      letterSpacing: '0px',
      fontWeight: 400,
    },
  },

  // Label styles (for buttons, inputs, etc.)
  label: {
    large: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 500,
    },
    medium: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 500,
    },
    small: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 500,
    },
    xsmall: {
      fontSize: 10,
      lineHeight: '14px',
      fontWeight: 500,
    },
  },
} as const;
